export default "__VITE_ASSET__50fhk272__"